<template>
  <div class="container-xxl">        
        <div>
            <div style="padding:20px 50px 0px 50px;"></div>
            <Createdtype ref="con1" v-if="typeControlPermission"  />
            <div v-else>
              <span v-text="'您沒有該活動類型管理權限'"></span>
            </div>            
        </div>
  </div>
  
</template>
<script>
import * as moment from "moment/moment";
import Createdtype from "./Createdtype.vue" 
import { mapState } from "vuex"; 
 


export default {
  name: 'Type_control', 
  components: {
    Createdtype
  },     
  data() {
    return {
      data: [],
      actives:{page1:false,page2:true,page3:false}
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["defaultval"]),
      typeControlPermission() {
        const currentVal = this.$route.name;
        // 取得 acts_permissions 陣列，從 defaultval.permissions.acts_permissions
        const acts_permissions = this.defaultval?.permissions?.acts_permissions || [];
        // 找到 vals 為 Advancementoption 的主功能
        const adv = acts_permissions.find(item => item.vals === "Advancementoption");
        if (!adv) return null;
        // 在其 acts_detailpermission 裡找 vals 為 Type_control 的細項
        return adv.acts_detailpermission.find(d => d.vals === currentVal) || null;
      }    
  },
  mounted() {
    //this.fetch({results:4,page:1,pageSize: 4,pid:this.user.data.user.id });
  },
  methods: {

    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },
  
  },
};
</script>